export default {
  DASH_NOTIFICATIONS_GET_START: 'DASH_NOTIFICATIONS_GET_START' ,
  DASH_NOTIFICATIONS_GET_FAILURE: 'DASH_NOTIFICATIONS_GET_FAILURE' ,
  DASH_NOTIFICATIONS_GET_SUCCESS: 'DASH_NOTIFICATIONS_GET_SUCCESS' ,
  DASH_NOTIFICATIONS_UPDATE_FILTERS: 'DASH_NOTIFICATIONS_UPDATE_FILTERS',
  DASH_NOTIFICATIONS_UPDATE: 'DASH_NOTIFICATIONS_UPDATE',
  DASH_NOTIFICATIONS_UPDATE_READ: 'DASH_NOTIFICATIONS_UPDATE_READ',
  DASH_NOTIFICATIONS_UPDATE_HAS_TOTAL: 'DASH_NOTIFICATIONS_UPDATE_HAS_TOTAL',
  DASH_NOTIFICATIONS_CLEAR: 'DASH_NOTIFICATIONS_CLEAR',
  DASH_NOTIFICATIONS_GETMORE: 'DASH_NOTIFICATIONS_GETMORE',
  DASH_NOTIFICATIONS_ISOPEN: 'DASH_NOTIFICATIONS_ISOPEN',
}